export const STORAGE = 10;
export const DATABASE = 20;
export const SITE = 30;
export const SITE_CPU = 31;
export const SITE_MEMORY = 32;
export const CERTIFICATE = 40;
export const CRON = 50;
export const DOMAIN = 60;

export const typeMeta = {
  [STORAGE]: {
    groupKey: "storage",
    labelKey: "notification.contract_entity.storage.title",
    fallbackName: "Storage"
  },
  [DATABASE]: {
    groupKey: "database",
    labelKey: "notification.contract_entity.database.title",
    fallbackName: "Databases"
  },
  [SITE]: {
    groupKey: "site",
    labelKey: "notification.contract_entity.site.title",
    fallbackName: "Sites"
  },
  [CERTIFICATE]: {
    groupKey: "certificate",
    labelKey: "notification.contract_entity.certificate.title",
    fallbackName: "Certificates"
  },
  [CRON]: {
    groupKey: "cron",
    labelKey: "notification.contract_entity.cron.title",
    fallbackName: "Schedulers"
  },
  [DOMAIN]: {
    groupKey: "domain",
    labelKey: "notification.contract_entity.domain.title",
    fallbackName: "Domains"
  }
};

export function getBalanceEntityTypeMeta(typeId) {
  const numericTypeId = Number(typeId);

  if (!Number.isFinite(numericTypeId)) {
    return null;
  }

  return typeMeta[numericTypeId] || null;
}

export function getBalanceEntityGroupKey(typeId) {
  return getBalanceEntityTypeMeta(typeId)?.groupKey || "other";
}
